__turbopack_context__.v({
  "attributesSkeleton": "bqb42a_attributesSkeleton",
  "modalProductListContainer": "bqb42a_modalProductListContainer",
  "scrollableItemRow": "bqb42a_scrollableItemRow",
  "seeMoreText": "bqb42a_seeMoreText",
  "segment": "bqb42a_segment",
  "segments": "bqb42a_segments",
});
